export default __webpack_public_path__ + "static/header-15997801f441c37b8ef7d596a4e7c1c6.png";